// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1fhW0","label":"Completed_label__3So23"};